const reCapchaMixin = {
    methods: {
        async getRecaptchaToken(){
            if (process.env.VUE_APP_SKIP_RECAPTCHA === 'true') {
                return 'skip'
            }
            await this.$recaptchaLoaded();
            const recaptchaToken = await this.$recaptcha('provisionalEntry');

            return recaptchaToken
        }
    },
    async mounted(){
        if (process.env.VUE_APP_SKIP_RECAPTCHA === 'true') return;
        const sleep = (msec) => new Promise(resolve => setTimeout(resolve, msec))
        var recaptcha;
        // 送らせてインスタンスを取得しないと何故かNULLになる
        do {
          await sleep(10);
          recaptcha = this.$recaptchaInstance;
          // console.log(recaptcha);
        } while(!recaptcha);
        // バッジを表示する
        recaptcha.value.showBadge();
      },
      unmounted() {
        if (process.env.VUE_APP_SKIP_RECAPTCHA === 'true') return;
        // バッジを消す
        this.$recaptchaInstance.value.hideBadge();
      },
}

export default reCapchaMixin